import {useMemo, useState} from 'react'
import useQueryLotLog from '../../hooks/api/lotlogs/useQueryLotLog'
import Text from '../../components/text/Text'
import moment from 'moment'
import Span from '../../components/text/Span'
import Title from '../../components/text/Title'

export interface ILogSummaryProps {
    server_id?: string
    created_at?: string
}

const LogSummary: React.FC<ILogSummaryProps> = ({server_id, created_at}) => {
    const {data} = useQueryLotLog(server_id, created_at)

    const majors = useMemo(() => {
        if (data === undefined) {
            return
        }
        return Object.entries(data?.major).map(([key, value]) => {
            return (
                <div className="my-[15px]">
                    <Text className="mt-[8px] font-bold">{key}</Text>
                    <Span>{'  count:  ' + value.count}</Span>

                    <Text className="font-bold">
                        {'level'} <Span>{value.level}</Span>
                    </Text>

                    <Text className="font-bold">{'Message'}</Text>
                    <Text>{value.message}</Text>
                </div>
            )
        })
    }, [data])

    return (
        <>
            {data ? (
                <div
                    className="m-[40px] p-4 rounded-lg md:p-8 bg-gray-400"
                    id="about"
                    role="tabpanel"
                    aria-labelledby="about-tab">
                    <div className="">
                        <div className="flex justify-center content-center items-center">
                            <Title className="text-3xl font-extrabold tracking-tight text-gray-900 dark:text-white">
                                {data.server_id}
                            </Title>
                        </div>
                        <div className="flex justify-center content-center items-center">
                            <Text className="ml-[1rem] mr-[5px] text-gray-600">{`Total count for a hour:`}</Text>
                            <p className="mr-[1rem] text-orange-900">{`${data.count}`}</p>
                            <Text className="text-gray-900">
                                {moment.utc(data.day_time, 'YYYYMMDDHH').local().format('YY년 MM월 DD일 HH시')}
                            </Text>
                        </div>
                    </div>
                    <div className="mx-[1rem] divide-y">
                        <h1 className="font-extrabold">Major Logs</h1>
                        {majors}
                    </div>
                </div>
            ) : (
                <></>
            )}
        </>
    )
}

export default LogSummary
